import { render, staticRenderFns } from "./SubActionSelectorDialogComponent.vue?vue&type=template&id=448fb6fc&scoped=true&lang=pug"
import script from "./SubActionSelectorDialogComponent.vue?vue&type=script&lang=ts"
export * from "./SubActionSelectorDialogComponent.vue?vue&type=script&lang=ts"
import style0 from "./SubActionSelectorDialogComponent.vue?vue&type=style&index=0&id=448fb6fc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448fb6fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('448fb6fc')) {
      api.createRecord('448fb6fc', component.options)
    } else {
      api.reload('448fb6fc', component.options)
    }
    module.hot.accept("./SubActionSelectorDialogComponent.vue?vue&type=template&id=448fb6fc&scoped=true&lang=pug", function () {
      api.rerender('448fb6fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dialog/customDialogs/SubActionSelectorDialogComponent.vue"
export default component.exports